export default __webpack_public_path__ + "static/media/AnytimeCollectAppLogo.67182400.png";